module.exports = __webpack_public_path__ + "img/avg.a37f3dc7.svg";